<script setup>
  import { ref, watchEffect, useTemplateRef } from 'vue';
  import TideSpotSelectorLocation from '@/components/TideSpotSelectorLocation.vue';

  const props = defineProps({
    tideSpot: {
      type: Object,
      required: true
    },
    isSelected: {
      type: Boolean,
      required: true
    }
  });

  const emits = defineEmits(['selected:tideSpot']); 

  const selectorElement = useTemplateRef('selector-element');

  const scrollToSelector = ref(true);

  const handleClick = () => {
    emits('selected:tideSpot', { id: props.tideSpot.id, type: props.tideSpot.type });
    scrollToSelector.value = false;
  };
  
  watchEffect(() => {
    if (props.isSelected && selectorElement.value && scrollToSelector.value) {
      setTimeout(() => {
        selectorElement.value?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 100);
    } else {
      scrollToSelector.value = true;
    }
  });
</script>

<template>
  <button
    ref="selector-element"
    :id="`tide-spot-${props.tideSpot.id}`"
    class="jwx-tide-spot-modal-selector jwx-table-view__row-action jwx-button"
    :data-selected="props.isSelected"
    @click.prevent="handleClick"
  >
    <TideSpotSelectorLocation :tideSpot="props.tideSpot" />
  </button>
</template>